import '@static/index.css';
import '@design/design-tokens/_radix-colors.scss';
import '@design/design-tokens/themes/themes.scss';
import '@design/components/custom-scroll/custom-scroll-global.scss';
import './utils/i18n/i18n';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { FloatingDelayGroup } from '@floating-ui/react';
import { getApplicationContainer } from '@helpers';
import { QueryClientProvider } from '@tanstack/react-query';
import { config } from '@terminal/config';
import { Routes } from '@terminal/routes';
import { queryClient } from '@terminal/services/query-client/queryClient';
import { Tracking } from '@terminal/services/tracking';
import { PostHogProvider } from '@terminal/services/tracking/posthog/PostHogProvider';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

const msalInstance = new PublicClientApplication(config.microsoft.config);

Tracking.initialise();

const root = createRoot(getApplicationContainer(), {
  onUncaughtError: (error, errorInfo) => {
    Tracking.captureException(error, {
      componentStack: errorInfo.componentStack ?? '',
    });
  },
  onRecoverableError: (error, errorInfo) => {
    Tracking.captureException(error, {
      componentStack: errorInfo.componentStack ?? '',
    });
  },
});

root.render(
  <MsalProvider instance={msalInstance}>
    <PostHogProvider>
      <QueryClientProvider client={queryClient}>
        <FloatingDelayGroup delay={{ open: 300, close: 0 }} timeoutMs={300}>
          <Routes />
        </FloatingDelayGroup>
      </QueryClientProvider>
    </PostHogProvider>
  </MsalProvider>
);
